<template>
    <v-card-actions>
        <!--Alternative route displayed on the left i.e. "Do you want to login?"-->
        <router-link v-if="hasAlternativeRoute" :to="alternativeRoute">
            {{ alternativeRouteText }}
        </router-link>
        <v-spacer></v-spacer>

        <!--Secondary Button-->
        <w-btn
            v-if="!hideSecondaryButton"
            v-bind="secondaryButtonProps"
            v-on="secondaryButtonEvents"
            v-text="secondaryButtonProps.text"
        ></w-btn>

        <!--Primary Button-->
        <w-btn
            v-if="!hidePrimaryButton"
            v-bind="primaryButtonProps"
            v-on="primaryButtonEvents"
            v-text="primaryButtonProps.text"
        ></w-btn>

        <!-- @slot Additional form actions. -->
        <slot></slot>
    </v-card-actions>
</template>

<script>
    import {isEmpty} from 'underscore'
    import WBtn from '../WBtn'
    import WCardFormActionsMixin from '../../mixins/forms/w-card-form-actions-mixin'

    export default {
        name: 'WCardFormActions',
        mixins: [WCardFormActionsMixin],
        components: {
            WBtn
        },
        computed: {
            hasAlternativeRoute () {
                const vm = this
                return !isEmpty(vm.alternativeRoute)
            },
            primaryButtonProps () {
                const vm = this
                return {
                    color: vm.primaryButtonColor,
                    disabled: vm.primaryButtonDisabled || vm.loading,
                    id: 'primary-button',
                    loading: vm.loading,
                    text: vm.primaryButtonText
                }
            },
            primaryButtonEvents () {
                return {
                    click: () => this.$emit(this.primaryButtonEvent)
                }
            },
            secondaryButtonProps () {
                const vm = this
                return {
                    color: vm.secondaryButtonColor,
                    disabled: vm.secondaryButtonDisabled || vm.loading,
                    id: 'secondary-button',
                    text: vm.secondaryButtonText
                }
            },
            secondaryButtonEvents () {
                return {
                    click: () => this.$emit(this.secondaryButtonEvent)
                }
            }
        }
    }
</script>
